import { Card, Typography, Tooltip } from "antd";
import { ShopOutlined, IdcardOutlined, EnvironmentOutlined } from "@ant-design/icons";
const { Text } = Typography;

export default function ProveedoresPOCards({ proveedores = [] }) {

  const total = proveedores.length;
  const conIdentificacion = proveedores.filter((p) => p.identificacion).length;
  const conDireccion = proveedores.filter((p) => p.direccion).length;

  const cards = [
    { title: "Proveedores", value: total, description: "Proveedores registrados", icon: <ShopOutlined />, color: "#1677ff" },
    { title: "Con identificación", value: conIdentificacion, description: "Proveedores con NIT/identificación registrada", icon: <IdcardOutlined />, color: "#52c41a" },
    { title: "Con dirección", value: conDireccion, description: "Proveedores con dirección registrada", icon: <EnvironmentOutlined />, color: "#722ed1" }
  ];

  return (
    <div style={{ display: "flex", gap: 16, marginBottom: 24, flexWrap: "wrap" }}>
      {cards.map((card, i) => (
        <Card key={i} hoverable style={{ flex: "1 1 200px", borderRadius: 12, padding: 14, boxShadow: "0 4px 10px rgba(0,0,0,0.05)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <Text style={{ color: "#6b7280", fontSize: 13, display: "block", marginBottom: 6 }}>{card.title}</Text>
              <Tooltip title={card.description}>
                <div style={{ fontSize: 26, fontWeight: 700, color: "#111827", cursor: "help" }}>{card.value}</div>
              </Tooltip>
            </div>
            <div style={{ background: card.color + "20", color: card.color, width: 48, height: 48, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>
              {card.icon}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
